import requests from 'api/index';

const prefixURL = '/pims/calendar';
export default {
  createCalender: payload => requests.post(`${prefixURL}/rest/v1/calendars/create`, payload),
  createHoliday: payload =>
    requests.post(`${prefixURL}/rest/v1/calendars/${payload.code}/schedules/create`, payload.data),
  deleteHoliday: payload =>
    requests.post(
      `${prefixURL}/rest/v1/calendars/${payload.code}/schedules/${payload.uid}/delete?recurrenceModType=ALL`,
      payload,
    ),
};
